import React, { useState, useRef } from 'react';
import i18n, { t } from 'i18next';
import { useAppSelector, useAppDispatch } from '../stores/hooks';
import { RootState } from '../stores/store';
import { setSession } from '../stores/sessionSlice';
import AuthenticatedLayout from '../layout/AuthenticatedLayout';
import userDefaultImage from '../images/user-default.png';
import ApiService from '../services/ApiService';
import './Profile.scss';

const Profile = (): React.JSX.Element => {
  const session = useAppSelector((state: RootState) => state.session);
  const dispatch = useAppDispatch();
  // const [isEditing, setIsEditing] = useState(false);
  // const [isUpdating, setIsUpdating] = useState(false);
  // const [formData, setFormData] = useState({
  //   name: session?.name || '',
  //   email: session?.email || ''
  // });

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [language, setLanguage] = useState<string>(i18n.language || 'pt');

  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };

  // const handleSave = async () => {
  //   if (!session?.id_token) {
  //     console.error('Token de acesso não encontrado');
  //     return;
  //   }
  //
  //   setIsUpdating(true);
  //
  //   try {
  //     const response = await ApiService.put('/users/profile', {
  //       name: formData.name,
  //       email: formData.email
  //     });
  //
  //     if (response.status === 200) {
  //       const updatedSession = {
  //         ...session,
  //         name: formData.name,
  //         email: formData.email
  //       };
  //
  //       dispatch(setSession(updatedSession));
  //
  //       console.log('Perfil atualizado com sucesso!');
  //
  //       setIsEditing(false);
  //     } else {
  //       console.error('Falha ao atualizar perfil');
  //     }
  //   } catch (error) {
  //     console.error('Erro ao atualizar perfil:', error);
  //   } finally {
  //     setIsUpdating(false);
  //   }
  // };

  // const handleCancel = () => {
  //   setFormData({
  //     name: session?.name || '',
  //     email: session?.email || ''
  //   });
  //   setIsEditing(false);
  // };

  // const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (file) {
  //     if (!file.type.startsWith('image/')) {
  //       alert('Por favor, selecione apenas arquivos de imagem.');
  //       return;
  //     }
  //     if (file.size > 5 * 1024 * 1024) {
  //       alert('A imagem deve ter no máximo 5MB.');
  //       return;
  //     }
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       const imageData = event.target?.result as string;
  //       if (session) {
  //         const updatedSession = {
  //           ...session,
  //           picture: imageData
  //         };
  //         localStorage.setItem('sessionData', JSON.stringify(updatedSession));
  //         dispatch(setSession(updatedSession));
  //         console.log('Foto atualizada com sucesso!');
  //       }
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  // const openFileSelector = () => {
  //   fileInputRef.current?.click();
  // };

  const handleLanguageChange = (newLang: 'pt' | 'en') => {
    setLanguage(newLang);
    try {
      localStorage.setItem('app_lang', newLang);
      document.cookie = `app_lang=${newLang}; path=/; max-age=${60 * 60 * 24 * 365}`;
    } catch {}
    i18n.changeLanguage(newLang);
  };

  const handleLanguageSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = (e.target.value || 'pt') as 'pt' | 'en';
    handleLanguageChange(newLang);
  };

  if (!session) {
    return <div>Carregando...</div>;
  }

  return (
    <AuthenticatedLayout>
      <div className="profile-container">


      <div className="profile-content">
        <div className="profile-section">
          <div className="profile-avatar">
                          <img
                src={session.picture || userDefaultImage}
                alt="Avatar do usuário"
                className="avatar-image"
              />
            {/** Área de mudança de avatar desabilitada temporariamente */}
            {/**
            <div className="avatar-overlay">
              <button
                className="btn btn-primary btn-sm"
                onClick={openFileSelector}
                type="button"
              >
               {t("profile.avatar.change")}
              </button>
            </div>
            */}
          </div>
        </div>

        <div className="profile-section">
          <h3>{t("profile.title")}</h3>
          <div className="form-group">
            <label htmlFor="name">{t("profile.fields.name")}</label>
            <div className="info-display">
              <span>{session.name}</span>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email">{t("profile.fields.email")}</label>
            <div className="info-display">
              <span>{session.email}</span>
            </div>
          </div>

          <div className="form-group">
            <label>{t("profile.fields.id")}</label>
            <div className="info-display">
              <span className="text-muted">{session.id}</span>
            </div>
          </div>

          {/** Ações de edição desabilitadas temporariamente */}
          {/**
          {isEditing && (
            <div className="profile-actions">
              <button
                onClick={handleSave}
                className="btn btn-primary me-2"
                disabled={isUpdating}
              >
                {isUpdating ? t("profile.info.saving") : t("profile.info.save")}
              </button>
              <button
                onClick={handleCancel}
                className="btn btn-secondary"
                disabled={isUpdating}
              >
                {t("profile.info.cancel")}
              </button>
            </div>
          )}
          */}
        </div>

        <div className="profile-section">
          <h3>{t("profile.settings.title")}</h3>
          <div className="settings-list">
            {/** Item de alterar senha desabilitado temporariamente */}
            {/**
            <div className="setting-item">
              <span>{t("profile.settings.changePassword")}</span>
              <button className="btn btn-outline-primary btn-sm">
                {t("profile.settings.changePassword")}
              </button>
            </div>
            */}
            <div className="setting-item d-flex align-items-center mt-3">
                <span className="me-2">{t("profile.language.title")}</span>
              <select
                className="form-select form-select-sm"
                style={{ width: 'auto' }}
                value={language}
                onChange={handleLanguageSelectChange}
                aria-label={t("profile.language.select")}
              >
                <option value="pt">{t("profile.language.pt")}</option>
                <option value="en">{t("profile.language.en")}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/** Input de arquivo oculto desabilitado temporariamente */}
      {/**
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handlePhotoChange}
        style={{ display: 'none' }}
      />
      */}
      </div>
    </AuthenticatedLayout>
  );
};

export default Profile;
